import { bl_sys_vendor_login_subject_link_RowClass } from "../../dbschema/bl_sys_vendor_login_subject_link.model";
import { BaseContainerModel } from "../base-container.model";

export class VendorLoginSubjectLinkContainerModel extends BaseContainerModel {
  bl_sys_vendor_login_subject_link: bl_sys_vendor_login_subject_link_RowClass =
    new bl_sys_vendor_login_subject_link_RowClass();
}
